import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'
import {
  ACCESSTOKEN,
  COMPANY_ID,
  USER_ID,
} from './../../../constants/local_storage'
import { func } from 'prop-types'

function* loadDataDashborad(action) {
  const {
    data: {
      start_date,
      end_date,
      location_visibility,
      is_vendor,
      is_admin,
      company_id,
      group_by,
      filterObj,
      accesstoken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/getDataIsuppyDashBorad-new`,
      {
        start_date,
        end_date,
        location_visibility,
        is_vendor,
        is_admin,
        company_id,
        filterObj,
        group_by,
      },
      { headers: { Authorization: `Bearer ${accesstoken}` } }
    )

    yield put(actions.loadDataDashborad.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadDataDashborad.failure())
  }
}
// *Start ดึงข้อมูลมาแสดงหน้า Dashboard การขนส่งวัตถุดิบ
function* loadDataIsupplyDashboard(action) {
  const {
    data: {
      location_visibility,
      material_visibility,
      exactly_location,
      mill_location_list,
      plant_location_list,
      is_vendor,
      is_admin,
      company_id,
      order_by_field,
      order_by,
      group_by,
      filterObj,
      offset,
      limit,
      is_saleorder_page,
      accesstoken,
      check_load,
    },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/getDataIsupplyDashboard`,
      {
        location_visibility,
        material_visibility,
        exactly_location,
        mill_location_list,
        plant_location_list,
        is_vendor,
        is_admin,
        company_id,
        filterObj,
        order_by_field,
        order_by,
        group_by,
        offset,
        limit,
        is_saleorder_page,
      },
      { headers: { Authorization: `Bearer ${accesstoken}` } }
    )

    yield put(
      actions.loadDataIsupplyDashboard.success(
        res.data,
        offset,
        group_by,
        check_load
      )
    )
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadDataIsupplyDashboard.failure())
  }
}
// *End ดึงข้อมูลมาแสดงหน้า Dashboard การขนส่งวัตถุดิบ

function* loadOngoing(action) {
  const {
    data: {
      location_visibility,
      is_vendor,
      page,
      pageSize,
      filterObj,
      company_id,
      accesstoken,
    },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply/dashboard/ongoing`,
      {
        location_visibility,
        company_id,
        is_vendor,
        page,
        pageSize,
        filterObj,
      },
      { headers: { Authorization: `Bearer ${accesstoken}` } }
    )

    yield put(actions.loadOngoing.success(res.data, page))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadOngoing.failure())
  }
}

function* loadSuccess(action) {
  const {
    data: {
      location_visibility,
      is_vendor,
      page,
      pageSize,
      filterObj,
      company_id,
      accesstoken,
    },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply/dashboard/success`,
      {
        location_visibility,
        company_id,
        is_vendor,
        page,
        pageSize,
        filterObj,
      },
      { headers: { Authorization: `Bearer ${accesstoken}` } }
    )

    yield put(actions.loadSuccess.success(res.data, page))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadSuccess.failure())
  }
}

function* loadAvailable(action) {
  const {
    data: {
      location_visibility,
      is_vendor,
      page,
      pageSize,
      filterObj,
      company_id,
      accesstoken,
    },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply/dashboard/available`,
      {
        location_visibility,
        company_id,
        is_vendor,
        page,
        pageSize,
        filterObj,
      },
      { headers: { Authorization: `Bearer ${accesstoken}` } }
    )

    yield put(actions.loadAvailable.success(res.data, page))
  } catch (err) {
    yield put(actions.loadAvailable.failure())
  }
}

function* loadWorkALL(action) {
  const {
    data: {
      location_visibility,
      is_vendor,
      page,
      pageSize,
      filterObj,
      company_id,
      accesstoken,
    },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply/dashboard/all`,
      {
        location_visibility,
        company_id,
        is_vendor,
        page,
        pageSize,
        filterObj,
      },
      { headers: { Authorization: `Bearer ${accesstoken}` } }
    )

    yield put(actions.loadWorkALL.success(res.data, page))
  } catch (err) {
    yield put(actions.loadWorkALL.failure())
  }
}

function* loadAvailableForEdit(action) {
  const {
    data: { id, accesstoken },
  } = action.payload

  try {
    const res = yield call(
      axios.get,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply/getfor/edit/${id}`,
      { headers: { Authorization: `Bearer ${accesstoken}` } }
    )
    yield put(actions.loadAvailableForEdit.success(res.data))
  } catch (err) {
    yield put(actions.loadAvailableForEdit.failure())
  }
}

function* updateDataTricket(action) {
  const {
    data: {
      id,
      quantity,
      origin_locations_id,
      dest_locations_id,
      silo_no,
      contract_shipping_rate,
      shipping_rate,
      update_by,
      vehicles_id,
      driver_id,
      contractor_id,
      sub_contractor,
      accesstoken,
    },
    loading,
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply/edit/ticket`,
      {
        id,
        quantity,
        origin_locations_id,
        dest_locations_id,
        silo_no,
        contract_shipping_rate,
        shipping_rate,
        update_by,
        vehicles_id,
        driver_id,
        contractor_id,
        sub_contractor,
        matching_name: 'isupply-dashboard',
        action_name: 'update-dp',
      },
      { headers: { Authorization: `Bearer ${accesstoken}` } }
    )
    loading(res.data)
    yield put(actions.updateDataTricket.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.updateDataTricket.failure())
  }
}

function* loadDataVehicleForView(action) {
  const {
    data: { id, accesstoken },
  } = action.payload

  try {
    const res = yield call(
      axios.get,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply/dashboard/get/detail-vehicle/${id}`,
      { headers: { Authorization: `Bearer ${accesstoken}` } }
    )
    yield put(actions.loadDataVehicleForView.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadDataVehicleForView.failure())
  }
}

function* reCalculatorAreaNotCovered(action) {
  const {
    data: { id, location_type, accesstoken },
    loading,
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/re-calculator-area-not-covered`,
      {
        id,
        location_type,
      },
      { headers: { Authorization: `Bearer ${accesstoken}` } }
    )
    loading(res.data)
    yield put(actions.reCalculatorAreaNotCovered.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.reCalculatorAreaNotCovered.failure())
  }
}

function* calculatorDeliveryOutsideTheArea(action) {
  const {
    data: { id, accesstoken },
    loading,
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/calculator-delivery-outsidethearea`,
      {
        id,
      },
      { headers: { Authorization: `Bearer ${accesstoken}` } }
    )
    loading(res.data)
    yield put(actions.calculatorDeliveryOutsideTheArea.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.calculatorDeliveryOutsideTheArea.failure())
  }
}

function* createLogRequestChangeDestLocation(action) {
  const {
    data: {
      id,
      do_number,
      isupply_do_id,
      previous_isupply_do_id,
      location_id,
      location_name,
      previous_location_id,
      previous_location_name,
      type,
      request_by,
      request_name_by,
      request_at,
      request_note,
      approve_by,
      approve_name_by,
      approve_at,
      approve_note,
      status,
      accesstoken,
    },
    loading,
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/create-log-request-change-dest-location`,
      {
        id,
        do_number,
        isupply_do_id,
        previous_isupply_do_id,
        location_id,
        location_name,
        previous_location_id,
        previous_location_name,
        type,
        request_by,
        request_name_by,
        request_at,
        request_note,
        approve_by,
        approve_name_by,
        approve_at,
        approve_note,
        status,
      },
      { headers: { Authorization: `Bearer ${accesstoken}` } }
    )
    loading(res.data)
    yield put(actions.createLogRequestChangeDestLocation.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.createLogRequestChangeDestLocation.failure())
  }
}

function* isupplyDashboardCloseWork(action) {
  const {
    data: { isupply_do_id, problem, comment, close_by, accesstoken },
    loading,
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-dashboard-close-work`,
      {
        isupply_do_id,
        problem,
        comment,
        close_by,
      },
      { headers: { Authorization: `Bearer ${accesstoken}` } }
    )
    loading(res.data)
    yield put(actions.isupplyDashboardCloseWork.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.isupplyDashboardCloseWork.failure())
  }
}

// *load detail ประเมินคุณภาพ (ต้นแหล่ง)
function* sourceQualityControlLogLoadDetail(action) {
  const {
    data: { id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control/detail`,
      { id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.sourceQualityControlLogLoadDetail.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.sourceQualityControlLogLoadDetail.failure())
  }
}

// *export 1 form ประเมินคุณภาพ
function* sourceQualityControlLogExportOneForm(action) {
  const {
    data: { id, type, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control/export`,
      { id, type },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.sourceQualityControlLogExportOneForm.success(res.data))
    window.open(res.data.data, '_blank')
  } catch (err) {
    console.log(err.message)
    yield put(actions.sourceQualityControlLogExportOneForm.failure())
  }
}

// *ดึงข้อมูล form ประเมินคุณภาพสินค้า
function* loadEvaluationForm(action) {
  const {
    data: { isupply_do_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-dashboard/request-product-quality-assessment`,
      { isupply_do_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.loadEvaluationForm.success(isupply_do_id, res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadEvaluationForm.failure())
  }
}

// *submit form ประเมินคุณภาพสินค้า
function* submitEvaluationForm(action) {
  const {
    data: { data, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-dashboard/submit-product-quality-assessment`,
      {
        ...data,
        matching_name: 'isupply-dashboard',
        action_name: 'create-product-quality-assessment',
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.submitEvaluationForm.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.submitEvaluationForm.failure())
  }
}
// *เปลี่ยนต้นทางหลายรายการ
function* changeOriginLocationMultiple(action) {
  const {
    data: { ticket_list, origin_locations_id, update_by, accesstoken },
    loading,
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-dashboard/change-origin-multiple`,
      {
        ticket_list,
        origin_locations_id,
        update_by,
        matching_name: 'isupply-dashboard',
        action_name: 'update-dp',
      },
      { headers: { Authorization: `Bearer ${accesstoken}` } }
    )
    loading(res.data)
    yield put(actions.changeOriginLocationMultiple.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.changeOriginLocationMultiple.failure())
  }
}

// *load division
function* isupplyDashboardLoadDivision(action) {
  const {
    data: {
      location_visibility,
      division_id,
      department_id,
      section_id,
      plant_id,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-dashboard/load-division`,
      { location_visibility, division_id, department_id, section_id, plant_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.isupplyDashboardLoadDivision.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.isupplyDashboardLoadDivision.failure())
  }
}

// *load department
function* isupplyDashboardLoadDepartment(action) {
  const {
    data: { location_visibility, division_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-dashboard/load-department`,
      { location_visibility, division_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.isupplyDashboardLoadDepartment.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.isupplyDashboardLoadDepartment.failure())
  }
}

// *load section
function* isupplyDashboardLoadSection(action) {
  const {
    data: { location_visibility, division_id, department_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-dashboard/load-section`,
      { location_visibility, division_id, department_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.isupplyDashboardLoadSection.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.isupplyDashboardLoadSection.failure())
  }
}

// *load plant
function* isupplyDashboardLoadPlant(action) {
  const {
    data: {
      location_visibility,
      division_id,
      department_id,
      section_id,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-dashboard/load-plant`,
      { location_visibility, division_id, department_id, section_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.isupplyDashboardLoadPlant.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.isupplyDashboardLoadPlant.failure())
  }
}

// *ส่ง GR อีกครั้ง
function* isupplyDashboardResendGR(action) {
  const {
    data: { id, isupply_material_quality_assessment_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-dashboard/resend-gr`,
      { id, isupply_material_quality_assessment_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.isupplyDashboardResendGR.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.isupplyDashboardResendGR.failure())
  }
}

// *ค้นหาตั๋ว รับสินค้าเปลี่ยนปลายทาง
function* isupplyDashboardChangeDestSearchTicket(action) {
  const {
    data: { do_number, accessToken },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/search-isupply-do-by-payload`,
      {
        do_number,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.isupplyDashboardChangeDestSearchTicket.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.isupplyDashboardChangeDestSearchTicket.failure())
  }
}

// *ประเมินรับสินค้าแบบเปลี่ยนปลายทาง
function* isupplyDashboardEvaluationFormChangeDest(action) {
  const {
    data: { isupply_do_id, location_visibility, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-plant-for-change-destination`,
      { isupply_do_id, location_visibility },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(
      actions.isupplyDashboardEvaluationFormChangeDest.success(res.data)
    )
  } catch (err) {
    console.log(err.message)
    yield put(actions.isupplyDashboardEvaluationFormChangeDest.failure())
  }
}

// *export dp
function* isupplyDashboardExportDP(action) {
  const {
    data: { id, type, accessToken },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_CPAC_ISUPPLY_REPORT_GO}/export-dp`,
      { id, type },
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    )

    yield put(actions.isupplyDashboardExportDP.success(res.data))
    if (res.data.result === null) {
      return
    }

    window.location = res.data.result
  } catch (err) {
    console.log(err.message)
    yield put(actions.isupplyDashboardExportDP.failure())
  }
}

function* loadIsupplySourceReadinessForManage(action) {
  const {
    data: { user_id, start_date, end_date, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/source-readiness/get-for-manage`,
      { user_id, start_date, end_date },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.loadIsupplySourceReadinessForManage.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadIsupplySourceReadinessForManage.failure())
  }
}

function* updateIsupplySourceReadiness(action) {
  const {
    data: { user_id, start_date, end_date, checked_key, accessToken },
    loading,
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/source-readiness/update`,
      { user_id, start_date, end_date, checked_key },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    loading(res.data)
    yield put(actions.updateIsupplySourceReadiness.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.updateIsupplySourceReadiness.failure())
  }
}

function* checkIsupplySourceReadinessConfirm(action) {
  const {
    data: { user_id, start_date, end_date, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/source-readiness/check-confirm`,
      { user_id, start_date, end_date },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    console.log('checkIsupplySourceReadinessConfirm : ', res.data)
    yield put(actions.checkIsupplySourceReadinessConfirm.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.checkIsupplySourceReadinessConfirm.failure())
  }
}

export default function* watchIsupplyDashboard() {
  yield all([
    takeEvery(actions.LOAD_ONGOING.REQUEST, loadOngoing),
    takeEvery(actions.LOAD_SUCCESS.REQUEST, loadSuccess),
    takeEvery(actions.LOAD_AVALIABLE.REQUEST, loadAvailable),
    takeEvery(actions.LOAD_ALL.REQUEST, loadWorkALL),
    takeEvery(actions.LOAD_AVALIABLE_FOR_EDIT.REQUEST, loadAvailableForEdit),
    takeEvery(actions.UPDATE_DATA_TRICKET.REQUEST, updateDataTricket),
    takeEvery(
      actions.LOAD_DATA_VEHICLE_FOR_VIEW.REQUEST,
      loadDataVehicleForView
    ),
    takeEvery(actions.NEW_LOAD_DATA_DASHBORAD.REQUEST, loadDataDashborad),
    takeEvery(
      actions.RECALCULATOR_AREA_NOT_COVERED.REQUEST,
      reCalculatorAreaNotCovered
    ),
    takeEvery(
      actions.CALCULATOR_DELIVERRY_OUTSIDE_THE_AREA.REQUEST,
      calculatorDeliveryOutsideTheArea
    ),
    takeEvery(
      actions.CREATE_LOG_REQUEST_CHANGE_DEST_LOCATION.REQUEST,
      createLogRequestChangeDestLocation
    ),
    takeEvery(
      actions.ISUPPLY_DASHBOARD_CLOSE_WORK.REQUEST,
      isupplyDashboardCloseWork
    ),
    takeEvery(
      actions.LOAD_DATA_ISUPPLY_DASHBOARD.REQUEST,
      loadDataIsupplyDashboard
    ),
    takeEvery(
      actions.SOURCE_QUALITY_CONTROL_LOG_DETAIL.REQUEST,
      sourceQualityControlLogLoadDetail
    ),
    takeEvery(
      actions.SOURCE_QUALITY_CONTROL_LOG_EXPORT_ONE_FORM.REQUEST,
      sourceQualityControlLogExportOneForm
    ),
    takeEvery(
      actions.ISUPPLY_DASHBOARD_LOAD_EVALUATION_FORM.REQUEST,
      loadEvaluationForm
    ),
    takeEvery(
      actions.ISUPPLY_DASHBOARD_SUBMIT_EVALUATION_FORM.REQUEST,
      submitEvaluationForm
    ),
    takeEvery(
      actions.ISUPPLY_DASHBOARD_CHANGE_ORIGIN_LOCATION_MULTIPLE.REQUEST,
      changeOriginLocationMultiple
    ),

    takeEvery(
      actions.ISUPPLY_DASHBOARD_LOAD_DIVISION.REQUEST,
      isupplyDashboardLoadDivision
    ),
    takeEvery(
      actions.ISUPPLY_DASHBOARD_LOAD_DEPARTMENT.REQUEST,
      isupplyDashboardLoadDepartment
    ),
    takeEvery(
      actions.ISUPPLY_DASHBOARD_LOAD_SECTION.REQUEST,
      isupplyDashboardLoadSection
    ),
    takeEvery(
      actions.ISUPPLY_DASHBOARD_LOAD_PLANT.REQUEST,
      isupplyDashboardLoadPlant
    ),
    takeEvery(
      actions.ISUPPLY_DASHBOARD_RESEND_GR.REQUEST,
      isupplyDashboardResendGR
    ),
    takeEvery(
      actions.ISUPPLY_DASHBOARD_CHANGE_DEST_SEARCH_TICKET.REQUEST,
      isupplyDashboardChangeDestSearchTicket
    ),
    takeEvery(
      actions.ISUPPLY_DASHBOARD_EVALUATION_FORM_CHANGE_DEST.REQUEST,
      isupplyDashboardEvaluationFormChangeDest
    ),
    takeEvery(
      actions.ISUPPLY_DASHBOARD_EXPORT_DP.REQUEST,
      isupplyDashboardExportDP
    ),
    takeEvery(
      actions.ISUPPLY_SOURCE_READINESS_FOR_MANAGE.REQUEST,
      loadIsupplySourceReadinessForManage
    ),
    takeEvery(
      actions.UPDATE_ISUPPLY_SOURCE_READINESS.REQUEST,
      updateIsupplySourceReadiness
    ),
    takeEvery(
      actions.CHECK_ISUPPLY_SOURCE_READINESS_CONFIRM.REQUEST,
      checkIsupplySourceReadinessConfirm
    ),
  ])
}

export {
  loadOngoing,
  loadSuccess,
  loadAvailable,
  loadWorkALL,
  loadAvailableForEdit,
  loadDataVehicleForView,
  updateDataTricket,
  loadDataDashborad,
  reCalculatorAreaNotCovered,
  calculatorDeliveryOutsideTheArea,
  createLogRequestChangeDestLocation,
  isupplyDashboardCloseWork,
  loadDataIsupplyDashboard,
  sourceQualityControlLogLoadDetail,
  sourceQualityControlLogExportOneForm,
  loadEvaluationForm,
  submitEvaluationForm,
  changeOriginLocationMultiple,
  isupplyDashboardLoadDivision,
  isupplyDashboardLoadDepartment,
  isupplyDashboardLoadSection,
  isupplyDashboardLoadPlant,
  isupplyDashboardResendGR,
  isupplyDashboardChangeDestSearchTicket,
  isupplyDashboardEvaluationFormChangeDest,
  isupplyDashboardExportDP,
  loadIsupplySourceReadinessForManage,
  updateIsupplySourceReadiness,
  checkIsupplySourceReadinessConfirm,
}
